import { render, staticRenderFns } from "./materialSelect.vue?vue&type=template&id=f462f47a&scoped=true&"
import script from "./materialSelect.vue?vue&type=script&lang=js&"
export * from "./materialSelect.vue?vue&type=script&lang=js&"
import style0 from "./materialSelect.vue?vue&type=style&index=0&id=f462f47a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f462f47a",
  null
  
)

export default component.exports